import { Component, Input, inject } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { SharedModule } from '@app/shared/shared.module';
import { Router } from '@angular/router';
import { Utilities } from '@app/core/utils/utilities';
import { CourseType } from '@app/shared/enm/course-instance.enum';

@Component({
    selector: 'app-no-course',
    templateUrl: './no-course.component.html',
    styleUrl: './no-course.component.css',
    imports: [SharedModule]
})
export class NoCourseComponent {
  util = inject(Utilities);
  dialog = inject(MatDialog);
  @Input() courseTypeId = CourseType.GeneralCourseTypeId;

  openCourseType() {
    this.util.isDialogOpen$.set(true);
    const dialogRef = this.dialog.open(CourseTypeDialog, { panelClass: 'course_type_selection' });
    dialogRef.afterClosed().subscribe(result => {
      this.util.isDialogOpen$.set(false);
    })
  }
}


@Component({
    selector: 'coursetypedialog',
    templateUrl: './coursetypedialog.html',
    styleUrl: './no-course.component.css',
    imports: [SharedModule]
})
export class CourseTypeDialog {
  router = inject(Router);
  courseTypeDetails = CourseType;
  selectedCourse: any = this.courseTypeDetails.GeneralCourseTypeId;
  eflCoursesAvailability = JSON.parse(localStorage.getItem("institutionDetails") ?? '')?.eflCoursesAvailability;

  createNewCourse() {
    this.router.navigateByUrl('/add-course/' + this.selectedCourse);
  }

  updateSelectedCourseType(courseTypeId: string) {
    this.selectedCourse = courseTypeId;
  }
}
